enum BordereauActionType {
	ANNULER_REDUIRE = 'ANNULER_REDUIRE',
	DENUMEROTER = 'DENUMEROTER',
	METTRE_EN_ECHEC = 'METTRE_EN_ECHEC',
	MODIFIER_BORDEREAU = 'MODIFIER_BORDEREAU',
	NUMEROTER = 'NUMEROTER',
	PES_EN_INSTANCE = 'PES_EN_INSTANCE',
	EMETTRE_LE_FLUX = 'EMETTRE_LE_FLUX',
	EMETTRE_LE_FLUX_360 = 'EMETTRE_LE_FLUX_360',
	SUPPRIMER = 'SUPPRIMER',
	DUPLIQUER = 'DUPLIQUER',
	ACTUALISER_ETAT = 'ACTUALISER_ETAT',
	FORCE_ACK = 'FORCE_ACK',
	FORCE_NACK = 'FORCE_NACK',
	STATUT_ANTERIEUR = 'STATUT_ANTERIEUR',
	ANNULER_REJET = 'ANNULER_REJET',
	RELANCER_FLUX = 'RELANCER_FLUX',
	RELANCER_FLUX_360 = 'RELANCER_FLUX_360',
	FORCE_TRAITE_DGFIP = 'FORCE_TRAITE_DGFIP',
	REJETER_COLLECTIVITE = 'REJETER_COLLECTIVITE',
}

export default BordereauActionType;
